export enum TypeReseau {
    TOUS = 'tous',
    TRIPHASE = 'triphase',
    BASSE_TENSION_EXCLUE = 'basseTensionExclue'
}
